import { lazy } from 'react';

const SectorEdit = lazy(() => import('./SectorEdit'));

export default SectorEdit;
